import { AE_palette } from "../style/theme";

export const getInitials = (name) => {
    if (!name) return "?";
    
    if (name.includes("_")) {
      const nameParts = name.split("_");
      return (nameParts[0][0] + (nameParts[1] ? nameParts[1][0] : "")).toUpperCase();
    } else if (name.includes(".")) {
      const nameParts = name.split(".");
      return (nameParts[0][0] + (nameParts[1] ? nameParts[1][0] : "")).toUpperCase();
    } else if (name.includes(" ")) {
      const nameParts = name.split(" ");
      return (nameParts[0][0] + (nameParts[1] ? nameParts[1][0] : "")).toUpperCase();
    } else {
      return name.substring(0, 2).toUpperCase();
    }
  };
  
  const getAvatarColor = (name) => {
    if (!name) return AE_palette.silver;
    
    const brandColors = [
      AE_palette.melonRed,
      AE_palette.seafoamGreen,
      AE_palette.orchidPurple,
      AE_palette.charcoal
    ];
    if (brandColors.length === 0) return AE_palette.silver;
    
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    const colorIndex = Math.abs(hash) % brandColors.length;
    return brandColors[colorIndex];
  };
  
  export default getAvatarColor;